/* Our cookie banner (snippets/nw-consent.liquid). The visitor's choice goes to Shopify's Customer Privacy API, which
   blocks or allows Shopify's own cookies, the web pixels and checkout. Our own record of it (proof of consent) goes to
   the nw-consent worker. Scripts that don't listen to Shopify wait as <script type="text/plain" data-nw-consent="..">
   and start here once their category is allowed.
   window.NWConsent: allowed('analytics'|'marketing'|'preferences'), open() for the settings, pending() while the
   banner waits for an answer. The 'nw:consent' event fires after every choice. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nwcc]');
  if (!root || window.NWConsent) return;
  var V = root.dataset.v, LOG = root.dataset.log, KEY = 'nw-consent';
  var first = root.querySelector('[data-nwcc-first]'), set = root.querySelector('[data-nwcc-set]');
  var CATS = ['preferences', 'analytics', 'marketing'];
  var cp = null, waiting = [];
  /* known: whether the banner is needed has been decided (Shopify's privacy API loads late); until then it counts as pending */
  var known = false, onKnown = [];
  function decided() { known = true; onKnown.splice(0).forEach(function (f) { f(); }); }

  /* our own small record in the browser: banner version and the random ID the proof is filed under */
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { } }
  function newId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  /* outside the consent regions (US, rest of world) Shopify allows by default; these calls know the region */
  function allowed(cat) {
    if (!cp) return false;
    if (cat === 'analytics') return cp.analyticsProcessingAllowed();
    if (cat === 'marketing') return cp.marketingAllowed();
    if (cat === 'preferences') return cp.preferencesProcessingAllowed();
    return false;
  }
  function current() { var o = {}; CATS.forEach(function (k) { o[k] = allowed(k); }); return o; }

  /* scripts waiting for consent: replaced by a real copy once their category is allowed */
  function activate() {
    document.querySelectorAll('script[type="text/plain"][data-nw-consent]').forEach(function (s) {
      if (!allowed(s.getAttribute('data-nw-consent'))) return;
      var n = document.createElement('script');
      for (var i = 0; i < s.attributes.length; i++) {
        var a = s.attributes[i];
        if (a.name !== 'type' && a.name !== 'data-nw-consent') n.setAttribute(a.name, a.value);
      }
      if (!s.src) n.text = s.text;
      s.replaceWith(n);
    });
  }

  function proof(choice, action, rec) {
    if (!LOG) return;
    var body = {
      id: rec.id, sid: (cp.consentId && cp.consentId()) || '', v: V, lang: document.documentElement.lang || '',
      region: (cp.getRegion && cp.getRegion()) || '', action: action,
      analytics: choice.analytics ? 1 : 0, marketing: choice.marketing ? 1 : 0, preferences: choice.preferences ? 1 : 0
    };
    try { fetch(LOG, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) }).catch(function () { }); } catch (e) { }
  }

  /* cookies and storage the partners left behind, removed when their category is switched off again
     (Google Analytics in Statistik; Google Ads, Meta and BixGrow in Marketing) */
  var LEFTOVERS = { analytics: [/^_ga/], marketing: [/^_gcl_/, /^_fbp$/, /^_fbc$/, /^bg(visitor_id|affilite_id|last_click|expire_time|click_id|cart)$/], preferences: [] };
  function clearLeftovers(cat) {
    var host = location.hostname.replace(/^www\./, '');
    document.cookie.split('; ').forEach(function (c) {
      var n = c.split('=')[0];
      if (!LEFTOVERS[cat].some(function (r) { return r.test(n); })) return;
      ['', host, '.' + host].forEach(function (d) { document.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + (d ? '; domain=' + d : ''); });
    });
    try { Object.keys(localStorage).forEach(function (k) { if (LEFTOVERS[cat].some(function (r) { return r.test(k); })) localStorage.removeItem(k); }); } catch (e) { }
  }

  function hide() { root.hidden = true; root.classList.remove('is-set'); }
  function showFirst() { root.hidden = false; set.hidden = true; first.hidden = false; root.classList.remove('is-set'); }
  function openSettings() {
    if (!cp) { waiting.push(openSettings); return; }
    var now = current();
    set.querySelectorAll('[data-nwcc-cat]').forEach(function (b) { b.setAttribute('aria-checked', String(!!now[b.dataset.nwccCat])); });
    root.hidden = false; first.hidden = true; set.hidden = false; root.classList.add('is-set');
    var f = set.querySelector('[data-nwcc-cat]'); if (f) f.focus({ preventScroll: true });
  }

  function choose(choice, action) {
    var before = current();
    hide();
    cp.setTrackingConsent({ analytics: choice.analytics, marketing: choice.marketing, preferences: choice.preferences }, function () {
      var r = read(), rec = { v: V, id: r.id || newId(), t: Date.now(), c: { analytics: !!choice.analytics, marketing: !!choice.marketing, preferences: !!choice.preferences } };
      write(rec);
      proof(choice, action, rec);
      /* something switched off that was on: clear what it left and reload, so scripts already running stop */
      var off = CATS.filter(function (k) { return before[k] && !choice[k]; });
      if (off.length) { off.forEach(clearLeftovers); setTimeout(function () { location.reload(); }, 300); return; }
      activate();
      document.dispatchEvent(new CustomEvent('nw:consent', { detail: current() }));
    });
  }

  root.addEventListener('click', function (e) {
    /* a tap on the dimmed page beside the settings closes them, once a first choice exists */
    if (e.target === root) { if (!root.dataset.first) hide(); return; }
    var t = e.target.closest('button'); if (!t || !cp) return;
    if (t.hasAttribute('data-nwcc-all')) { var on = t.getAttribute('data-nwcc-all') === '1'; choose({ analytics: on, marketing: on, preferences: on }, on ? 'accept_all' : 'reject_all'); }
    else if (t.hasAttribute('data-nwcc-open')) openSettings();
    else if (t.hasAttribute('data-nwcc-cat')) t.setAttribute('aria-checked', String(t.getAttribute('aria-checked') !== 'true'));
    else if (t.hasAttribute('data-nwcc-save')) {
      var c = {}; set.querySelectorAll('[data-nwcc-cat]').forEach(function (b) { c[b.dataset.nwccCat] = b.getAttribute('aria-checked') === 'true'; });
      choose(c, 'save');
    }
  });
  /* Escape leaves the settings: back to the first card while no choice is made yet, otherwise closed */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || root.hidden || set.hidden) return;
    if (root.dataset.first) showFirst(); else hide();
  });
  /* the footer link (and any link to #cookie-settings) opens the settings */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#cookie-settings"]'); if (!a) return;
    e.preventDefault(); openSettings();
  });

  function start() {
    cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp) { decided(); return; }
    var c = cp.currentVisitorConsent(), undecided = CATS.some(function (k) { return !c[k]; }), mine = read();
    /* Shopify lost an answer this browser gave to this banner (seen in Chrome incognito: the next page asked again):
       the visitor's own recorded choice is given back to Shopify instead of asking twice */
    if (cp.shouldShowBanner() && undecided && mine.v === V && mine.c) {
      cp.setTrackingConsent({ analytics: mine.c.analytics, marketing: mine.c.marketing, preferences: mine.c.preferences }, activate);
    }
    /* asked again when the banner's wording changed (data-v) or the answer came from somewhere we have no proof of */
    else if (cp.shouldShowBanner() && (undecided || mine.v !== V)) { root.dataset.first = '1'; showFirst(); }
    decided();
    activate();
    document.addEventListener('visitorConsentCollected', activate);
    waiting.splice(0).forEach(function (f) { f(); });
    if (location.hash === '#cookie-settings') openSettings();
  }
  /* the first answer is given: from now on the settings close instead of going back */
  document.addEventListener('nw:consent', function () { delete root.dataset.first; });

  window.NWConsent = { allowed: allowed, open: openSettings, pending: function () { return !known || !root.hidden; }, known: function (f) { if (known) f(); else onKnown.push(f); } };

  if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) start();
  else if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) start(); else decided(); });
  else decided();
})();
